import React from 'react';

import { ReactComponent as ExclamationMarkCircle } from 'media/svg/exclamationMarkCircle.svg';

import styles from '../AiSmartFilter.module.scss';

export interface ErrorMessageProps {
    title: string;
    hint?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ title, hint }) => {
    return (
        <div className={styles.ErrorMessage}>
            <ExclamationMarkCircle className={styles.ExclamationMarkCircle} />
            <div className={styles.ErrorText}>
                <div className={styles.ErrorTitle}>{title}</div>
                {hint && <div className={styles.ErrorHint}>{hint}</div>}
            </div>
        </div>
    );
};

export default ErrorMessage;
